module.exports = __webpack_public_path__ + "img/icon10.f1d5bc2b.png";